import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Button, Svg } from 'ui'
import ButtonArrow from 'images/button-arrow-right.svg'
import { navigate } from 'gatsby'
import ScalablePricingPlansIcon from 'images/organization/industries/schools/scalable-pricing-plans.svg'
import ScalablePricingPlansContainer from 'components/Organization/Industries/Common/ScalablePricingPlansContainer'

export default function ScalablePricingPlans(): ReactElement {
  return (
    <ScalablePricingPlansContainer>
      <Flex
        sx={{
          width: ['auto', '48rem'],
          flexDirection: 'column',
          my: '4rem',
          mx: ['1.2rem', 0],
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Svg svg={ScalablePricingPlansIcon} descriptiveText="Scalable Pricing Plans" />
        <Flex sx={{ width: '100%', flexDirection: 'column', gap: '0.8rem' }}>
          <Text
            variant="size28Weight600"
            as="h2"
            sx={{
              color: 'aliceBlue',
            }}
          >
            Scalable pricing plans for schools & districts
          </Text>
          <Text
            variant="size15Weight400Line138Letter03"
            as="h2"
            sx={{
              color: 'wildBlueYonder',
            }}
          >
            Try Control D risk-free for 30 days
          </Text>
        </Flex>
        <Flex
          sx={{
            mt: '4rem',
            gap: '0.8rem',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Button
            data-testid="take-it-now-button"
            sx={{
              whiteSpace: 'nowrap',
              maxWidth: '15.4rem',
              height: '3.5rem',
              alignItems: 'center',
              py: 0,
              px: '1.6rem',
            }}
            variant="gradientButton"
            ariaLabel="Start Free Trial"
            name="Start Free Trial"
            onClick={() => navigate('/onboard')}
          >
            <Text variant="size15Weight600Line138">Start Free Trial</Text>
            <Svg
              svg={ButtonArrow}
              sx={{
                ml: '0.6rem',
              }}
              descriptiveText="Right arrow icon for Start Free Trial button"
            />
          </Button>
          <Text variant="size12Weight500Line136Letter012" sx={{ color: 'wildBlueYonder70' }}>
            Special Discounts for Schools & Districts
          </Text>
        </Flex>
      </Flex>
    </ScalablePricingPlansContainer>
  )
}
